import { axiosHttpClientAdapter } from "infra/adapters";
import { alyviaCoreServiceApi } from "utils/constants";

export function getAccountById(Id: string) {
  return axiosHttpClientAdapter.get(`${alyviaCoreServiceApi}/account/${Id}`);
}
